import { Directive } from '@angular/core';

@Directive({
  selector: '[prEventableHeaderIcon]',
  standalone: false,
})
export class EventableHeaderIconDirective {}
